export type VuexLearningHistoryActionNameList =
  | "ACHIEVEMENT_REQUEST"
  | "ACTIVITY_SUMMARY_REQUEST"
  | "LEARNING_STATS_REQUEST"
  | "EXERCISE_LOGS_REQUEST"
  | "PERFORMANCE_SUMMARY_REQUEST"
  | "SEND_FEEDBACK"
  | "RECENT_EXERCISES_REQUEST";

export type VuexLearningHistoryActionNames = {
  [T in VuexLearningHistoryActionNameList]: string;
};

export type VuexLearningHistoryMutationNameList =
  | "ACHIEVEMENT"
  | "ACTIVITY_SUMMARY"
  | "EXERCISE_LOGS"
  | "LEARNING_STATS"
  | "PERFORMANCE_SUMMARY"
  | "SELECTED_EXERCISE_LOG_TYPE_AND_SKILL"
  | "RECENT_EXERCISES"
  | "LOADING";

export type VuexLearningHistoryMutationNames = {
  [T in VuexLearningHistoryMutationNameList]: string;
};

export const VUEX_LEARNING_HISTORY_NAMESPACE = "learningHistory";

export const VUEX_LEARNING_HISTORY_ACTION_NAMES: VuexLearningHistoryActionNames = {
  ACHIEVEMENT_REQUEST: "achievement_request",
  ACTIVITY_SUMMARY_REQUEST: "activity_summary_request",
  EXERCISE_LOGS_REQUEST: "exercise_logs_request",
  LEARNING_STATS_REQUEST: "learning_stats_request",
  PERFORMANCE_SUMMARY_REQUEST: "performance_summary_request",
  SEND_FEEDBACK: "send_feedback",
  RECENT_EXERCISES_REQUEST: "recent_exercises_request"
};

export const VUEX_LEARNING_HISTORY_MUTATION_NAMES: VuexLearningHistoryMutationNames = {
  ACHIEVEMENT: "achievement",
  ACTIVITY_SUMMARY: "activity_summary",
  EXERCISE_LOGS: "exercise_logs",
  LEARNING_STATS: "learning_stats",
  PERFORMANCE_SUMMARY: "performance_summary",
  SELECTED_EXERCISE_LOG_TYPE_AND_SKILL: "selected_exercise_log_type_and_skill",
  RECENT_EXERCISES: "recent_exercises",
  LOADING: "loading"
};
